import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
function getPopoverPositionAdjustedStyles({ open, placement, tip, }) {
    const translationValue = `${open ? 8 : 0}px`;
    const marginValue = `${tip ? 12 : 0}px`;
    switch (placement) {
        case 'top':
            return `
        margin: ${marginValue} 0;
        transform: translateY(-${translationValue});
        `;
        case 'left':
            return `
        margin: 0 ${marginValue};
        transform: translateX(-${translationValue});
        `;
        case 'right':
            return `
        margin: 0 ${marginValue};
        transform: translateX(${translationValue});
        `;
        case 'bottom':
        default:
            return `
        margin: ${marginValue} 0;
        transform: translateY(${translationValue});`;
    }
}
function getArrowPosition({ placement }) {
    const margin = '-8px';
    const position = '100%';
    switch (placement) {
        case 'top':
            return `
        top: ${position};
        margin-left: ${margin};
      `;
        case 'left':
            return `
        left: ${position};
        margin-top: ${margin};
      `;
        case 'right':
            return `
        right: ${position};
        margin-top: ${margin};
      `;
        case 'bottom':
        default:
            return `
      bottom: ${position};
      margin-left: ${margin};
    `;
    }
}
function getArrowTransform({ placement }) {
    // Note: the translation is in part a fix and in part repositioning because
    // we're just rotating the canvas and the tip is centered on it with empty space around
    // https://stackoverflow.com/questions/44170229/how-to-prevent-half-pixel-svg-shift-on-high-pixel-ratio-devices-retina
    // The appropriate number is 8 but the additional pixel helps
    // avoiding a glitch on the outline focus in Chrome
    const displacement = '9px';
    switch (placement) {
        case 'top':
            return `transform: translate(0, -${displacement}) rotate(180deg)`;
        case 'left':
            return `transform: translate(-${displacement}, 0) rotate(90deg)`;
        case 'right':
            return `transform: translate(${displacement}, 0) rotate(270deg)`;
        case 'bottom':
        default:
            return `transform: translate(0, ${displacement}) rotate(0deg)`;
    }
}
export const StyledPopover = styled.div.withConfig({ displayName: "auir-611444a-StyledPopover", componentId: "auir-611444a-8dst9i" }) `
  box-sizing: border-box;
  /* Force the popover to maintain the container padding on both sides */
  max-width: ${(props) => !props.width ? `calc(100% - ${props.containerPadding * 2}px)` : 'none'};

  background-color: var(${(props) => props.theme.colors.background.level[2]});

  opacity: ${(props) => (props.open ? 1 : 0)};

  filter: var(${(props) => props.theme.shadow.background.level[2]});
  // Hotfix for drop-shadow artifacting on Safari browsers.
  // https://stackoverflow.com/questions/56478925/safari-drop-shadow-filter-remains-visible-even-with-hidden-element
  will-change: filter;
  width: ${(props) => props.width && `${props.width}px`};

  transition-timing-function: var(${(props) => props.theme.easing});
  transition-duration: ${(props) => `${props.transitionDuration}ms`};
  transition-property: transform, opacity;
  ${({ keepContentHeight }) => keepContentHeight && 'max-height: fit-content !important;'}

  ${() => getPopoverPositionAdjustedStyles}
`;
// NOTE: we have to use minmax(0,1fr) for grid-template-rows below to prevent
// uncontrolled overflow of the column.
// More details in the article "Preventing a Grid Blowout": https://css-tricks.com/preventing-a-grid-blowout/
export const StyledPopoverContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledPopoverContainer", componentId: "auir-611444a-95g6h" }) `
  display: grid;
  grid-template-areas:
    '. . .'
    '. content .'
    '. . .';
  grid-template-rows:
    var(${(props) => props.theme.responsive.spacing.m}) minmax(0, 1fr)
    var(${(props) => props.theme.responsive.spacing.m});
  grid-template-columns:
    var(${(props) => props.theme.responsive.spacing.m}) 1fr
    var(${(props) => props.theme.responsive.spacing.m});
  max-height: inherit;
`;
export const StyledPopoverBody = styled.div.withConfig({ displayName: "auir-611444a-StyledPopoverBody", componentId: "auir-611444a-1yo7e8j" }) `
  grid-area: content;
`;
export const StyledPopoverBodyInner = styled.div.withConfig({ displayName: "auir-611444a-StyledPopoverBodyInner", componentId: "auir-611444a-13x7kjf" }) `
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
`;
export const StyledTip = styled.svg.attrs({
    ariaHidden: true,
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
}).withConfig({ displayName: "auir-611444a-StyledTip", componentId: "auir-611444a-smp9cl" }) `
  position: absolute;
  ${() => getArrowPosition}
  ${() => getArrowTransform}
`;
export const StyledTriangle = styled.polygon.withConfig({ displayName: "auir-611444a-StyledTriangle", componentId: "auir-611444a-19z5dmy" }) `
  fill: var(${(props) => props.theme.colors.background.level[2]});
`;
//# sourceMappingURL=Popover.styles.mjs.mjs.map